<template>
  <div class="breadclumb">
    <router-link :to="hrefButton" class="button_back">
      <svg width="24" height="24" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 7.20166H3.83L9.42 1.61166L8 0.20166L0 8.20166L8 16.2017L9.41 14.7917L3.83 9.20166H16V7.20166Z" fill="#2966F5"/>
      </svg>
    </router-link>
    <ul>
      <li v-for="(item, index) in menu" :key="item.href">
        <router-link :to="item.href" :disabled="index === (menu.length - 1)">{{  item.label }}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  computed: {
    hrefButton () {
      return this.menu.slice(-2)[0].href
    }
  },
  props: [
    "menu"
  ],
}
</script>
<style>
.breadclumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
}
.breadclumb a {
  text-wrap: nowrap;
}
.breadclumb ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: #555555;
}
.breadclumb li:not(:last-of-type) a::after {
  content: "/";
  margin-left: 6px;
}
.breadclumb li:last-of-type a {
  font-weight: 700;
}
.breadclumb li:not(:last-of-type) a:hover {
  color: #2966F5;
}
.button_back {
  display: grid;
  place-items: center;
  border-radius: 100%;
  background-color: #E7EAFE;
  width: 32px;
  height: 32px;
}

@media screen and (max-width: 768px) {
  .breadclumb ul li {
    font-size: 12px;
  }
}
</style>